$(document).on("click", "#new_faculty_assignment #clearButton", function(e) {
  e.preventDefault()
  $(".faculty_id, .course_id, .faculty_role_id").val("").trigger("chosen:updated")
})
